import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner'

import '../../css/SingleScreens/UserProfileEditScreen.css';
import '../../css/InstantScreens/Instant.css';

import { Routes as routes, History as history } from '../../navigation';
import { ValidatorUtils, StringUtils, DateUtils } from '../../utils';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { TitleBar, SingleScreenNavBar, Input, Button, Errors, Header, Line, PhoneInput } from  '../../components'

class SubscriptionDetailsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit_section: '',
      contact_name: '',
      contact_email: '',
      contact_phone_number: '',
      cardholder_name: '',
      card_number: '',
      card_month: '',
      card_year: '',
      card_cvv: '',
      billing_street_address: '',
      billing_street_address_line_2: '',
      billing_city: '',
      billing_state: '',
      billing_zipcode: '',
      card_loading: false,
      cancel_sub_loading: false,
    }
  }

  componentDidMount() {
    this.props.practiceActions.getSelectedPractice();
  }

  renderEditSection = (edit_section) => {
    if (!edit_section) {
      return null;
    }

    if (edit_section === 'contact_info') {
      return this.renderEditContactInfo();
    }
    if (edit_section === 'card') {
      return this.renderChangeCard();
    }
    if (edit_section === 'cancel_subscription') {
      return this.renderCancelConfirmation();
    }
  }

  renderSubscriptionDetails = () => {
    let subscription = this.props.practice && this.props.practice.practiceSubscription ? this.props.practice.practiceSubscription : {};

    let teletails_sub = subscription.subscription;
    let stripe_sub    = subscription.stripe_subscription;
    let customer      = subscription.customer;
    let plan          = stripe_sub && stripe_sub.items && stripe_sub.items.data && stripe_sub.items.data[0] && stripe_sub.items.data[0].plan ? stripe_sub.items.data[0].plan : {};
    let amount        = plan && plan.amount   ? plan.amount   : null;
    let interval      = plan && plan.interval ? plan.interval : '';
    let is_per_year   = interval && interval === 'year';
    let plan_label    = this.getPlanLabel(teletails_sub);

    let rate_interval = is_per_year ? ' / year' : ' / month';
    let rate_string   = StringUtils.displayMoney(amount) + rate_interval;

    let last_4_str    = customer && customer.last4 ? customer.last4 : 'No Card Added';
    let display_card  = customer ? true : false;

    let start         = stripe_sub && stripe_sub.current_period_start ? stripe_sub.current_period_start * 1000 : 0;
    let ends          = stripe_sub && stripe_sub.current_period_end   ? stripe_sub.current_period_end   * 1000 : 0;

    let display_price = amount;

    let period_start  = DateUtils.getDateNumber(start) + ' ' + DateUtils.getShortMonth(start) + ', ' + DateUtils.getYear(start);
    let period_end    = DateUtils.getDateNumber(ends)  + ' ' + DateUtils.getShortMonth(ends)  + ', ' + DateUtils.getYear(ends);

    let enterprise    = subscription && subscription.enterprise ? subscription.enterprise : null;
    let display_cont  = enterprise;

    let is_canceled   = stripe_sub && stripe_sub.status && stripe_sub.status === 'canceled' ? true : false;

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        { this.renderEditSection(this.state.edit_section) }
        <div className="standard-container">
          <Header title='Subscription Details' icon='fas fa-sync-alt' />

          <div className='flex-container-column' style={{ padding: 15 }}>
            <div className="flex-container flex-container-column" style={{ }}>
              <span style={{ fontSize: 14, color: '#474747' }}>Subscription Plan: <span style={{ color: 'grey' }}>{ plan_label }</span></span>
              { display_price ? <span style={{ fontSize: 14, color: '#474747' }}>Rate: <span style={{ color: 'grey' }}>{ rate_string }</span></span> : null }
              { display_price && !is_canceled ? <div className='flex-container-row' style={{ justifyContent: 'space-between' }}>
                                  <span style={{ fontSize: 14, color: '#474747' }}>Current Cycle: <span style={{ color: 'grey' }}>{ period_start + ' - ' + period_end }</span></span>
                                  <span style={{ fontSize: 14, marginLeft: 10 }}
                                        className='icon-button'
                                        onClick={ () => {
                                          this.setState({ ...this.state, edit_section: 'cancel_subscription' });
                                        }}>Cancel Subscription</span>
                                </div> : null }
              { is_canceled ? <div style={{ marginTop: 10 }}>
                                <span style={{ fontSize: 14, color: '#1dc2ff' }}>{ 'Your ' + plan_label + ' subscription period will end on ' + period_end + '.'}</span>
                              </div>
                            : null }
            </div>

            { display_card ? <Line style={{ marginTop: 15, marginBottom: 15 }} /> : null }
            { display_card ? this.renderCardInformation(last_4_str) : null }

            { display_cont ? <Line style={{ marginTop: 15, marginBottom: 15 }} /> : null }
            { display_cont ? this.renderContactInfo(enterprise) : null }

          </div>
        </div>
      </div>
    </div>
  }

  renderCardInformation = (last_4_str) => {
    return <div className="flex-container-row" style={{ justifyContent: 'space-between' }}>
      <span style={{ fontSize: 14, color: '#474747' }}>Payment Card: <span style={{ color: 'grey' }}>{ ' **** - ' + last_4_str  }</span></span>
      <span style={{ fontSize: 14, marginLeft: 10 }}
            className='icon-button'
            onClick={() => {
              this.setState({ ...this.state, edit_section: 'card' });
            }}>Change Card</span>
    </div>
  }

  renderContactInfo = (enterprise) =>{
    let contact_info = enterprise && enterprise.content ? enterprise.content : {};
    let name         = contact_info.contact_name;
    let email        = contact_info.contact_email;
    let phone_number = contact_info.contact_phone_number;

    return <div className='flex-container-column'>
      <div className="flex-container-row" style={{ justifyContent: 'space-between', marginBottom: 3 }}>
        <span style={{ fontSize: 14, color: '#474747' }}>{ 'Contact Information' }</span>
        <span style={{ fontSize: 14, marginLeft: 10 }}
              className='icon-button'
              onClick={ () => {
                this.setState({
                  ...this.state,
                  edit_section: 'contact_info',
                  contact_name: name,
                  contact_email: email,
                  contact_phone_number: phone_number,
                });
              }}>Edit</span>
      </div>
      <span style={{ fontSize: 14, color: 'grey' }}>{ name  }</span>
      <span style={{ fontSize: 14, color: 'grey' }}>{ email }</span>
      <span style={{ fontSize: 14, color: 'grey' }}>{ StringUtils.displayCodePhoneNumber(phone_number) }</span>
    </div>
  }

  renderCancelConfirmation = () => {

    let subscription = this.props.practice && this.props.practice.practiceSubscription ? this.props.practice.practiceSubscription : {};

    let teletails_sub = subscription.subscription;
    let stripe_sub    = subscription.stripe_subscription;
    let customer      = subscription.customer;
    let plan_label    = this.getPlanLabel(teletails_sub);

    let ends          = stripe_sub && stripe_sub.current_period_end   ? stripe_sub.current_period_end   * 1000 : 0;
    let period_end    = DateUtils.getDateNumber(ends)  + ' ' + DateUtils.getShortMonth(ends)  + ', ' + DateUtils.getYear(ends);


    return <div className='standard-container'>
      <Header title='Cancel Subscription' icon='fas fa-times-circle' />
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-column' style={{ marginBottom: 15 }}>
          <span style={{ fontSize: 14, color: 'grey', marginBottom: 10 }}>Your current <span style={{ color: '#1dc2ff' }}>{ plan_label }</span> subscription will remain active until <span style={{ color: '#1dc2ff' }}>{ period_end }</span>. </span>
          <span style={{ fontSize: 14, color: 'grey' }}>Once the term comes to an end, your account will be switched to the <span style={{ color: '#1dc2ff' }}>FREE Instant plan</span>, where you will still be able to use TeleTails for Instant Sessions.</span>
        </div>
        { /* <div className='flex-container-row' style={{ justifyContent: 'flex-end' }}>
          <span className='header-button' onClick={() => { this.setState({ ...this.state, edit_section: '' }) }}>
            Don't Cancel
          </span>
          <span className='header-button'
                style={{ marginRight: -0 }}
                onClick={ () => {
                  let token        = this.props.user.auth.token;
                  let practice_id  = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : '';

                  this.props.practiceActions.cancelSubscription(token, practice_id, this.cancelSubscriptionCallback);
                  this.setState({ ...this.state, cancel_sub_loading: true });
                }}>
            <span className='fas fa-times-circle' style={{ marginRight: 5 }} />
            Cancel Subscription
          </span>
        </div> */ }
        <div>
          <span style={{ fontSize: 14, color: 'grey' }}>Email success@teletails.com for more details about subscription cancellation.</span>
        </div>
      </div>
    </div>
  }

  renderChangeCard = () => {
    return <div className='standard-container'>
      <Header title='Change Payment Card' icon='fas fa-credit-card' />
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row'>

          <div className='flex-container-column' style={{ width: 350, marginRight: 8 }}>
            <div className='flex-container-row' style={{ width: 250, alignItems: 'flex-start', marginBottom: 10 }}>
              <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Credit Card Info</span>
            </div>

            <Input placeholder="Cardholder Name"
                   value={this.state.cardholder_name}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5}}
                   onChange={ (event) => { this.setState({ ...this.state, cardholder_name: event.target.value }) }}
                  />

            <Input placeholder="Card Number"
                   value={this.state.card_number}
                   className='instant-input-default'
                   style={{ width: 265, marginBottom: 5}}
                   onChange={ (event) => { this.setState({ ...this.state, card_number: event.target.value }) }}
                  />
            <div className='flex-container-row'>
              <div className='flex-container-row'>
                <Input placeholder="MM"
                       value={this.state.card_month}
                       className='instant-input-default'
                       style={{ width: 50, marginBottom: 5, marginRight: 5, textAlign: 'center', padding: 0 }}
                       onChange={ (event) => { this.setState({ ...this.state, card_month: event.target.value }) }}
                      />
                <Input placeholder="YY"
                       value={this.state.card_year}
                       className='instant-input-default'
                       style={{ width: 50, marginBottom: 5, textAlign: 'center', padding: 0 }}
                       onChange={ (event) => { this.setState({ ...this.state, card_year: event.target.value }) }}
                      />
              </div>
              <div className='flex-container-row'>
                <Input placeholder="CVV"
                       value={this.state.card_cvv}
                       className='instant-input-default'
                       style={{ width: 100, marginBottom: 5, marginLeft: 60, textAlign: 'center', padding: 0 }}
                       onChange={ (event) => { this.setState({ ...this.state, card_cvv: event.target.value }) }}
                      />
              </div>
            </div>
          </div>

          <div className='flex-container-column' style={{ width: 320, marginLeft: 8 }}>
            <div className='flex-container-row' style={{ width: 250, alignItems: 'flex-start', marginBottom: 10 }}>
              <span style={{ color: '#575757', fontWeight: 'bold', fontSize: 14 }}>Billing Address</span>
            </div>

            <Input placeholder="Street Address"
                   value={this.state.billing_street_address}
                   className='instant-input-default'
                   style={{ width: 260, marginBottom: 5 }}
                   onChange={ (event) => { this.setState({ ...this.state, billing_street_address: event.target.value }) }}
                  />
            <Input placeholder="Street Address Line 2  (Optional)"
                   value={this.state.billing_street_address_line_2}
                   className='instant-input-default'
                   style={{ width: 260, marginBottom: 5 }}
                   onChange={ (event) => { this.setState({ ...this.state, billing_street_address_line_2: event.target.value }) }}
                  />

            <div className='flex-container-row'>
              <Input placeholder="City"
                     value={this.state.billing_city}
                     className='instant-input-default'
                     style={{ width: 175, marginRight: 5 }}
                     onChange={ (event) => { this.setState({ ...this.state, billing_city: event.target.value }) }}
                    />
              <Input placeholder="State"
                     value={this.state.billing_state}
                     className='instant-input-default'
                     style={{ width: 80, marginRight: 5 }}
                     onChange={ (event) => { this.setState({ ...this.state, billing_state: event.target.value }) }}
                    />
            </div>

            <div style={{ marginTop: 5 }}>
              <Input placeholder="Zipcode"
                     value={this.state.billing_zipcode}
                     className='instant-input-default'
                     style={{   width: 100  }}
                     onChange={ (event) => { this.setState({ ...this.state, billing_zipcode: event.target.value }) }}
                    />
            </div>
          </div>

        </div>

        <div className='flex-container-row' style={{ justifyContent: 'flex-end', marginTop: 15 }}>
          <span className='instant-cancel-button' onClick={ () => { this.setState({ ...this.state, edit_section: '', card_loading: false }) }}>
            <span style={{ fontSize: 14, color: '#1dc2ff' }}>Cancel</span>
          </span>
          <span className='instant-join-session-button'
                style={{ marginLeft: 5 }}
                onClick={ () => {
                  let token        = this.props.user.auth.token;
                  let practice_id  = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : '';
                  let contact_info = {
                    billing_street_address: this.state.billing_street_address,
                    billing_street_address_line_2: this.state.billing_street_address_line_2,
                    billing_city: this.state.billing_city,
                    billing_state: this.state.billing_state,
                    billing_zipcode: this.state.billing_zipcode,
                    cc_num: this.state.card_number,
                    cc_exp_month: this.state.card_month,
                    cc_exp_year: this.state.card_year,
                    cc_cvc: this.state.card_cvv,
                  }

                  this.props.practiceActions.changeSubscriptionCard(token, practice_id, contact_info, this.changeCardCallback);
                  this.setState({ ...this.state, card_loading: true });
                }}>
            <span style={{ fontSize: 14, color: 'white' }}>
              { this.state.card_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 10 }} /> : null }
              Save Card
            </span>
          </span>
        </div>

      </div>
    </div>
  }

  renderEditContactInfo = () => {
    return <div className='standard-container'>
      <Header title='Edit Contact Info' icon='fas fa-address-book' />
      <div className='flex-container-row'>

        <div className='flex-container-column' style={{ padding: 15 }}>
          <Input placeholder="Contact Name"
                 value={this.state.contact_name}
                 className='instant-input-default'
                 style={{ width: 265, marginBottom: 5 }}
                 onChange={ (event) => { this.setState({ ...this.state, contact_name: event.target.value }) }}
                />
          <Input placeholder="Contact Email Address"
                 value={this.state.contact_email}
                 className='instant-input-default'
                 style={{ width: 265, marginBottom: 5 }}
                 onChange={ (event) => { this.setState({ ...this.state, contact_email: event.target.value }) }}
                />

          <PhoneInput value={this.state.contact_phone_number}
                      style={{ fontSize: 13 }}
                      placeholder='Contact Phone #'
                      containerStyle={{ width: 265 }}
                      onChange={ (phone_number) => { this.setState({ ...this.state, contact_phone_number: phone_number }) }}/>
        </div>

        <div className='flex-container-column' style={{ padding: 15, justifyContent: 'space-between', flex: 1 }}>
          <div className='flex-container-column'>
            <span style={{ fontSize: 13, color: 'grey' }}>Teletails will use this information to contact your practice for subscription related details.</span>
          </div>
          <div className='flex-container-row' style={{ justifyContent: 'flex-end' }}>
            <span className='instant-cancel-button' onClick={ () => { this.setState({ ...this.state, edit_section: '' }) }}>
              <span style={{ fontSize: 14, color: '#1dc2ff' }}>Cancel</span>
            </span>
            <span className='instant-join-session-button'
                  style={{ marginLeft: 5 }}
                  onClick={ () => {
                    let token        = this.props.user.auth.token;
                    let practice_id  = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : '';
                    let contact_info = {
                      practice_id: practice_id,
                      contact_name: this.state.contact_name,
                      contact_email: this.state.contact_email,
                      contact_phone_number: this.state.contact_phone_number,
                    }

                    this.props.practiceActions.editEnterpriseObject(token, practice_id, contact_info, () => { this.setState({ ...this.state, edit_section: '' }) });
                  }}>
              <span style={{ fontSize: 14, color: 'white' }}>Save</span>
            </span>
          </div>
        </div>

      </div>
    </div>
  }

  render() {

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Subscription Details" />
        { this.renderSubscriptionDetails() }
      </div>
    );
  }

  getPlanLabel = (subscription) => {
    let subscription_type = subscription && subscription.subscription_type ? subscription.subscription_type : '';
    let label = '';

    let label_dict = {
      'INSTANT': 'Instant',
      'INSTANT_PAID': 'Instant+',
      'CORE': 'Professional',
      'ENTERPRISE': 'Enterprise'
    }

    label = label_dict[subscription_type];
    return label;
  }

  changeCardCallback = (success) => {
    if (success) {
      this.setState({
        ...this.state,
        card_loading: false,
        cardholder_name: '',
        card_number: '',
        card_month: '',
        card_year: '',
        card_cvv: '',
        billing_street_address: '',
        billing_street_address_line_2: '',
        billing_city: '',
        billing_state: '',
        billing_zipcode: '',
        edit_section: '',
      });
    } else {
      this.setState({ ...this.state, card_loading: false });
    }
  }

  cancelSubscriptionCallback = (success) => {
    if (success) {
      this.setState({ ...this.state, cancel_sub_loading: false, edit_section: '' });
    } else {
      this.setState({ ...this.state, cancel_sub_loading: false });
    }
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionDetailsScreen)
